// Zapamiętany wygląd panelu bocznego (per przeglądarka): szerokość, zwinięcie i otwarte grupy.

export const SIDER_DEFAULT_WIDTH = 248;
export const SIDER_MIN_WIDTH = 200;
export const SIDER_MAX_WIDTH = 440;
export const SIDER_COLLAPSED_WIDTH = 64;

const WIDTH_KEY = "admin.sider.width";
const COLLAPSED_KEY = "admin.sider.collapsed";
const OPEN_KEYS_KEY = "admin.sider.openKeys";

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Tryb prywatny / pełny storage — wygląd po prostu nie zostanie zapamiętany.
  }
}

export function clampSiderWidth(width: number): number {
  return Math.round(Math.min(SIDER_MAX_WIDTH, Math.max(SIDER_MIN_WIDTH, width)));
}

export function readSiderWidth(): number {
  const stored = Number(read(WIDTH_KEY));
  return Number.isFinite(stored) && stored > 0 ? clampSiderWidth(stored) : SIDER_DEFAULT_WIDTH;
}

export function writeSiderWidth(width: number): void {
  write(WIDTH_KEY, String(clampSiderWidth(width)));
}

export function readSiderCollapsed(): boolean {
  return read(COLLAPSED_KEY) === "true";
}

export function writeSiderCollapsed(collapsed: boolean): void {
  write(COLLAPSED_KEY, String(collapsed));
}

/** `null`, gdy nic nie zapisano (pierwsza wizyta) — wtedy panel otwiera wszystkie grupy. */
export function readSiderOpenKeys(): string[] | null {
  const stored = read(OPEN_KEYS_KEY);
  if (stored === null) return null;
  try {
    const parsed: unknown = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed.filter((key): key is string => typeof key === "string") : null;
  } catch {
    return null;
  }
}

export function writeSiderOpenKeys(keys: string[]): void {
  write(OPEN_KEYS_KEY, JSON.stringify(keys));
}
